<div [class]="listingBackground">
  <a class="flyingclub-summary__name" [routerLink]="['/flyingclub', flyingClub.id]">{{flyingClub.name}}</a>
  <a [routerLink]="['/flyingclub', flyingClub.id]"><app-review-overview *ngIf="flyingClub.reviewSummary"
    [reviewSummary]="flyingClub.reviewSummary" [sizeModifier]="'_small'"
    [noReviewsText]="'Be the first to review this flying club'"></app-review-overview></a>
  <a [routerLink]="['/flyingclub', flyingClub.id]">
    <div class="flyingclub-summary__fields">
      <div class="flyingclub-summary__field flyingclub-summary__field--clubtype">
        <div class="flyingclub-summary__label">Type of club:</div>
        <div class="flyingclub-summary__value">
          <img *ngIf="iconUrl" [src]="iconUrl" width="32" height="32" maxlength="32"><span>{{flyingClub.clubType}}</span>
        </div>
      </div>
      <div class="flyingclub-summary__field flyingclub-summary__field--newmembers">
        <div class="flyingclub-summary__label">Open to New Members:</div>
        <div class="flyingclub-summary__value" *ngIf="flyingClub.newMembers; else noPlaceholder">Yes</div>
      </div>
      <div class="flyingclub-summary__field flyingclub-summary__field--members">
        <div class="flyingclub-summary__label">Members:</div>
        <div class="flyingclub-summary__value">{{flyingClub.clubMembers}}</div>
      </div>
      <div class="flyingclub-summary__field flyingclub-summary__field--aircraft">
        <div class="flyingclub-summary__label">Aircraft:</div>
        <div class="flyingclub-summary__value">{{flyingClub.clubAircraft}}</div>
      </div>
      <div class="flyingclub-summary__field flyingclub-summary__field--phone">
        <div class="flyingclub-summary__label">Phone:</div>
        <div class="flyingclub-summary__value">
          <span *ngIf="flyingClub.phone1; else na">{{flyingClub.phone1 | phone}}</span>
        </div>
      </div>
    </div>
  </a>
</div>
<ng-template #na>
  <span class="flyingclub-summary__empty-value">N/A</span>
</ng-template>
<ng-template #noPlaceholder>
  <div class="flyingclub-summary__value">No</div>
</ng-template>
